import React from 'react';
import Header from '../../02_molecules/Header/Header';
import UserTable from '../../03_organisms/UserTable/UserTable';
import userType from '../../../types/userType';

interface UserOverviewTemplateProps {
  users?: userType[];
  onRefresh: () => void;
}

function UserOverviewTemplate(props: Readonly<UserOverviewTemplateProps>) {
  const { users, onRefresh } = props;

  return (
    <div>
      <header>
        <Header title="Sweet Bibi" searchBar />
      </header>
      <UserTable users={users} onRefresh={onRefresh} />
    </div>
  );
}

UserOverviewTemplate.defaultProps = {
  users: [],
};

export default UserOverviewTemplate;
